import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/main.css'

// Import Bootstrap JS
// import 'bootstrap/dist/js/bootstrap.bundle';
// Import Bootstrap Icons CSS
import 'bootstrap-icons/font/bootstrap-icons.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import { maskDirective } from './utils/maskDirective';

import SmartTable from 'vuejs-smart-table'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

import VueClipboard from 'vue3-clipboard'

const app = createApp(App);
app.component('VueDatePicker', VueDatePicker);
app.directive('mask', maskDirective);
app.use(SmartTable)
app.component('v-select', vSelect)

app.use(VueClipboard, {
    autoSetContainer: true,
    appendToBody: true,
  })
  app.use(store)
app.use(router) 
app.mount('#app')
